import "./CategorySection.css";
import { useNavigate } from "react-router-dom";
import {
    FaMobileAlt,
    FaLaptop,
    FaTshirt,
    FaCouch,
    FaClock,
    FaHeadphones,
    FaPaintBrush,
    FaFootballBall
} from "react-icons/fa";

function Categories() {

    const navigate = useNavigate();

    const categories = [

        {
            name: "Mobiles",
            icon: <FaMobileAlt />,
            color: "#eef2ff"
        },

        {
            name: "Laptops",
            icon: <FaLaptop />,
            color: "#ecfeff"
        },

        {
            name: "Fashion",
            icon: <FaTshirt />,
            color: "#fff7ed"
        },

        {
            name: "Furniture",
            icon: <FaCouch />,
            color: "#fef3c7"
        },

        {
            name: "Watches",
            icon: <FaClock />,
            color: "#f3e8ff"
        },

        {
            name: "Audio",
            icon: <FaHeadphones />,
            color: "#ecfccb"
        },

        {
            name: "Beauty",
            icon: <FaPaintBrush />,
            color: "#ffe4e6"
        },

        {
            name: "Sports",
            icon: <FaFootballBall />,
            color: "#dcfce7"
        }

    ];

    return (

        <section className="categories-section">

            <div className="section-header">

                <h2>Shop by Category</h2>

                <p>
                    Find exactly what you're looking for.
                </p>

            </div>

            <div className="categories-grid">

                {

                    categories.map((category) => (

                        <div
                            key={category.name}
                            className="category-card"
                            style={{
                                background: category.color
                            }}
                            onClick={() =>
                                navigate(`/category/${category.name}`)
                            }
                        >

                            <div className="category-icon">

                                {category.icon}

                            </div>

                            <h4>

                                {category.name}

                            </h4>

                        </div>

                    ))

                }

            </div>

        </section>

    );

}

export default Categories;